export default "__VITE_PUBLIC_ASSET__5070bcb4__"